import React from "react";

const CollegeDetails = ({ data, setTab, setType, setRefresh, refresh }) => {
  // Format date for better display
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Get request status text with styling
  const getRequestStatus = (status) => {
    const statusMap = {
      0: { text: "Pending", class: "pending" },
      1: { text: "Approved", class: "approved" },
      2: { text: "Rejected", class: "rejected" },
    };
    return statusMap[status] || { text: "Unknown", class: "unknown" };
  };

  const requestStatus = getRequestStatus(data?.request_status);

  return (
    <div className="clg-dtl-container">
      {/* College Header */}
      <div className="clg-dtl-header">
        <h1 className="clg-dtl-main-title">College Details</h1>
      </div>

      {/* College Info Card */}
      <div className="clg-dtl-info-card">
        <div className="clg-dtl-info-header">
          <div className="clg-dtl-thumbnail">
            {data?.image ? (
              <img
                src={data.image}
                alt="College"
                className="clg-dtl-college-image"
              />
            ) : (
              <div className="clg-dtl-thumbnail-placeholder">
                <span>No Image</span>
              </div>
            )}
          </div>
          <div className="clg-dtl-title-section">
            <h2 className="clg-dtl-college-title">
              {data?.clg_name || "College Name Not Available"}
            </h2>
            <div className="clg-dtl-status-badge">
              <span className={`clg-dtl-status ${requestStatus.class}`}>
                {requestStatus.text}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* College Information Section */}
      <div className="clg-dtl-section">
        <h3 className="clg-dtl-section-title">College Information</h3>
        <div className="clg-dtl-section-content">
          <div className="clg-dtl-details-grid">
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">College Name</span>
              <span className="clg-dtl-detail-value">
                {data?.clg_name || "NA"}
              </span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">College Type</span>
              <span className="clg-dtl-detail-value">
                {data?.college_type_name || "NA"}
              </span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">
                Affiliated University
              </span>
              <span className="clg-dtl-detail-value">
                {data?.university_affiliated_name || "NA"}
              </span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">
                College Administrator
              </span>
              <span className="clg-dtl-detail-value">
                {data?.college_admin || "NA"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Information Section */}
      <div className="clg-dtl-section">
        <h3 className="clg-dtl-section-title">Contact Information</h3>
        <div className="clg-dtl-section-content">
          <div className="clg-dtl-details-grid">
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">Official Email</span>
              <span className="clg-dtl-detail-value clg-dtl-email">
                {data?.official_email || "NA"}
              </span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">Mobile Number</span>
              <span className="clg-dtl-detail-value">
                {data?.country_code && data?.mobile_no
                  ? `${data.country_code} ${data.mobile_no}`
                  : "NA"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Location Information Section */}
      <div className="clg-dtl-section">
        <h3 className="clg-dtl-section-title">Location Information</h3>
        <div className="clg-dtl-section-content">
          <div className="clg-dtl-details-grid">
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">Address</span>
              <span className="clg-dtl-detail-value">
                {data?.address || "NA"}
              </span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">City</span>
              <span className="clg-dtl-detail-value">{data?.city || "NA"}</span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">State</span>
              <span className="clg-dtl-detail-value">
                {data?.state_name || "NA"}
              </span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">Country</span>
              <span className="clg-dtl-detail-value">
                {data?.country_name || "NA"}
              </span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">Zipcode</span>
              <span className="clg-dtl-detail-value">
                {data?.zipcode || "NA"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Request Information Section */}
      {/* <div className="clg-dtl-section">
        <h3 className="clg-dtl-section-title">Request Information</h3>
        <div className="clg-dtl-section-content">
          <div className="clg-dtl-details-grid">
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">Request ID</span>
              <span className="clg-dtl-detail-value clg-dtl-request-id">
                #{data?.request_id || "NA"}
              </span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">Request Status</span>
              <span
                className={`clg-dtl-detail-value clg-dtl-status ${requestStatus.class}`}
              >
                {requestStatus.text}
              </span>
            </div>
            <div className="clg-dtl-detail-item">
              <span className="clg-dtl-detail-label">Created Date</span>
              <span className="clg-dtl-detail-value">
                {data?.created_at ? formatDate(data.created_at) : "NA"}
              </span>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default CollegeDetails;
